import React from 'react';

class Navbar extends React.Component {
  constructor( props ) {
    super( props );
    this.state = {
      hasError: false,
      error: {},
      info: {}
    };
  }

  componentDidCatch( error, info ) {
    this.setState( {
      hasError: true,
      error: error,
      info: info
    } );
  }

  render( ) {
    if( this.state.hasError === false ) {
      return (
        <div className="navigation-container">
          <nav className="navigation-bar">
            {this.props.children}
          </nav>
        </div>
      );
    } else {
      return ( <div></div> );
    }
  }
}

class NavbarItem extends React.Component {
  constructor( props ){
    super( props );
    this.state = {
      caption: this.props.caption === undefined ? '' : this.props.caption,
      icon: this.props.icon === undefined ? '' : this.props.icon,
      textCase: this.props.textCase === undefined ? 'uppercase' : this.props.textCase,
      hasError: false,
      error: {},
      info: {}
    };

  }

  componentDidCatch( error, info ) {
    this.setState( {
      hasError: true,
      error: error,
      info: info
    } );
  }

  componentWillReceiveProps( nextProps ){
    this.setState( {
      caption: nextProps.caption === undefined ? '' : nextProps.caption,
      icon: nextProps.icon === undefined ? '' : nextProps.icon,
      textCase: nextProps.textCase === undefined ? 'uppercase' : nextProps.textCase
    } );
  }

  render(){
    let styles = {};
    styles['textTransform'] = this.state.textCase;
    if( this.state.hasError === false ) {
      return (
        <ul className={ ( this.props.submenuOpen ) ? 'navigation-bar-container open' : 'navigation-bar-container'} onClick={() => {
          this.props.setOpen( this.props.parentindex );
        }}>
          <li className="navigation-bar-nav-item">
            <a className="navigation-bar-nav-item-link">
              <span className="navigation-bar-nav-item-link-icon">
                <i className={this.state.icon} />
              </span>
              <span className="navigation-bar-nav-item-link-caption" style={styles}>
                {this.state.caption}
              </span>
            </a>
          </li>
          <ul className="navigation-bar-subitems-container">
            {this.props.children}
          </ul>
        </ul>
      );
    } else {
      return ( <span></span> );
    }
  }
}

class NavbarImageItem extends React.Component {

  constructor( props ){
    super( props );
    this.state = {
      caption: this.props.caption === undefined ? '' : this.props.caption,
      image: this.props.image === undefined ? '' : this.props.image,
      textCase: this.props.textCase === undefined ? 'uppercase' : this.props.textCase,
    };
  }

  componentWillReceiveProps( nextProps ){
    this.setState( {
      caption: nextProps.caption === undefined ? '' : nextProps.caption,
      image: nextProps.image === undefined ? '' : nextProps.image,
      textCase: nextProps.textCase === undefined ? 'uppercase' : nextProps.textCase
    } );
  }

  render() {
    let styles = {};
    styles['textTransform'] = this.state.textCase;
    return (
      <ul className={ ( this.state.submenuOpen ) ? 'navigation-bar-container open' : 'navigation-bar-container'} onClick={() => {
        this.setState( {
          submenuOpen: !this.state.submenuOpen
        } );
      }}>
        <li className="navigation-bar-nav-item">
          <a className="navigation-bar-nav-item-link">
            <img className="picture img-circle navigation-bar-nav-item-link-image" src={this.state.image} alt={this.state.caption} />
            <span className="navigation-bar-nav-item-link-caption" style={styles}>
              {this.state.caption}
            </span>
          </a>
        </li>
        <ul className="navigation-bar-subitems-container">
          {this.props.children}
        </ul>
      </ul>
    );
  }
}

class MenuItem extends React.Component {

  constructor( props ) {
    super( props );
    this.state = {
      caption: this.props.caption === undefined ? '' : this.props.caption,
      route: this.props.route === undefined ? '' : this.props.route,
      selectedicon: '',
      hasError: false,
      error: {},
      info: {}
    };
    this.handleClick = this.handleClick.bind( this );
  }

  componentDidCatch( error, info ) {
    this.setState( {
      hasError: true,
      error: error,
      info: info
    } );
  }

  componentWillReceiveProps( nextProps ){
    this.setState( {
      caption: nextProps.caption === undefined ? '' : nextProps.caption,
      route: nextProps.route === undefined ? '' : nextProps.route,
    } );
  }

  handleClick( e ) {
    e.preventDefault();
    if( this.props.onClick !== undefined ){
      e.target.route = this.state.route;
      this.props.onClick( e );
    }
  }

  render(){

    if( this.state.hasError === false ) {

      let hasdivider = this.props.divider === undefined ? false : true;

      let styles = {};

      if( hasdivider === true ){
        styles['borderBottom'] = 'solid 1pt #cfcfcf';
      }


      return(
        <li className="navigiation-bar-subitems-menu-item">
          <a href={this.state.route} className="navigiation-bar-subitems-link" onClick={this.handleClick}>
            {this.state.caption}
          </a>
        </li>
      );
    } else {
      return ( <span></span> );
    }
  }
}

export {
  Navbar,
  NavbarItem,
  NavbarImageItem,
  MenuItem
};



// WEBPACK FOOTER //
// ./src/presentation/Navigation.js